export default __webpack_public_path__ + "static/media/AdobeStock_13948851.dd97cfe6.jpg";